import Vue from 'vue'
import Vuex from 'vuex'
import cloneDeep from 'lodash.clonedeep'

import { validateProductResponse } from './../services/product.service'

Vue.use(Vuex)

const params = new URLSearchParams(window.location.search)
const widgetDomain = params.get('w_d')

let urlBase = process.env.VUE_APP_API_URL

// overwrite url for debugging and testing
if (widgetDomain) {
  urlBase = widgetDomain
}

const URL = `${urlBase}/via/client/products/getssr`
const localDataUrl = `${urlBase}/via/ui/localdata`

const getters = {
  products: ({ products }) => products,
  settings: ({ settings }) => settings,
  extraCss: ({ extraCss }) => extraCss,
  localData: ({ localData }) => localData,
  error: ({ error }) => error,
}

const mutations = {
  setProducts(state, data) {
    state.products = data.sortedProducts
    state.settings = data.widgetSettings
    state.extraCss = data.extraCss
  },
  setError(state, error) {
    state.error = error
  },
  setLocalData(state, data) {
    state.localData = data
  },
}

const actions = {
  async fetchProducts({ commit }, { gtin, manId }) {
    try {
      const query = manId ? `gtin=${gtin}&m_id=${manId}` : `gtin=${gtin}`
      const result = await fetch(`${URL}?${query}`)

      if (result.status !== 200) {
        commit('setError', true)
        return
      }

      const data = await result.json()

      validateProductResponse(data)

      commit('setProducts', data)
    } catch (err) {
      commit('setError', true)
    }
  },
  async fetchLocalData({ commit }, { manId }) {
    try {
      const result = await fetch(`${localDataUrl}/${manId}`)
      if (result.status === 204) {
        commit('setError', true)
        return
      }
      const data = await result.json()
      commit('setLocalData', data)
    } catch (err) {
      commit('setError', true)
    }
  },
}

const state = () => ({
  products: [],
  settings: {},
  extraCss: '',
  localData: {},
  error: false,
})

const store = {
  modules: {
    products: {
      getters,
      actions,
      mutations,
      state,
    },
  },
}

export default () => new Vuex.Store(cloneDeep(store))
